import React, { useEffect, useState } from "react";
import "../ConfirmedOrders/ConfirmedOrders.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { BaseUrl } from "../../App";
import BuyerServicesUrl from "../../BuyerServicesUrl";
import emptyOrders from "../../assets/empty-cart.png";

export default function ConfirmedOrders({ defaultStatus = "pending" }) {
  const navigate = useNavigate();

  const [orders, setOrders] = useState([]);
  const [status, setStatus] = useState(defaultStatus);
  const [loading, setLoading] = useState(true);

  const statusConfig = {
    pending: {
      label: "قيد الانتظار",
      className: "cobadge-pending",
    },
    completed: {
      label: "تم الاستلام",
      className: "cobadge-completed",
    },
    cancelled: {
      label: "ملغية",
      className: "cobadge-cancel",
    },
  };

  useEffect(() => {
    setStatus(defaultStatus);
  }, [defaultStatus]);

  const fetchOrders = async (status) => {
    try {
      setLoading(true);
      setOrders([]); 
const token = localStorage.getItem("token");

if (!token) {
  setOrders([]);
  setLoading(false);
  return;
}
      const res = await axios.get(
        `${BaseUrl}${BuyerServicesUrl.MyOrders}?status=${status}`,
        {
          headers: {
            // Authorization: `Bearer ${localStorage.getItem("token")}`,
           Authorization: `Bearer ${token}`,
          },
        }
      );
console.log(res.data);
      setOrders(res.data?.data || []);
    } catch (err) {
      console.log(err);
      setOrders([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders(status);
  }, [status]);

  return (
    <div className="orders-page mt-5 pt-5 mobileorders">
      <div className="container mt-5">
        <div className="row">
          
          {/* ===== Tabs ===== */}
          <div className="col-lg-3 tabssection">
            <div className="orders-right-tabs">
              <button
                className={`cright-tab ${status === "pending" ? "active" : ""}`}
                onClick={() => setStatus("pending")}
              >
                الطلبات الحالية
              </button>

              <button
                className={`cright-tab ${status === "completed" ? "active" : ""}`}
                onClick={() => setStatus("completed")}
              >
                الطلبات المكتملة
              </button>

              <button
                className={`cright-tab ${status === "cancelled" ? "active" : ""}`}
                onClick={() => setStatus("cancelled")}
              >
                الطلبات الملغية
              </button>
            </div>
          </div>

          {/* ===== Orders Section ===== */}
          <div className="col-lg-9 col-12">
            <div className="cards-wrapper mt-5">

              {/*  Loader */}
              {loading && (
                <div className="orders-loader text-center py-5">
                  <div className="loader-circle mb-3"></div>
                  <p className="fw-bold">جاري تحميل الطلبات...</p>
                </div>
              )}

              {!loading && orders.length === 0 && (
                <div className="empty-orders text-center py-5">
                  <img
                    src={emptyOrders}
                    alt="no orders"
                    className="empty-orders-img mb-4"
                  />
                  <h4 className="fw-bold">لا توجد طلبات</h4>
                  <p className="text-muted mt-2">
                    يمكنك البدء بالتسوق الآن وإنشاء طلب جديد
                  </p>
                  <button
                    className="favproducts text-white pt-2 pb-2 mt-3"
                    onClick={() => navigate("/")}
                  >
                    تصفح المنتجات
                  </button>
                </div>
              )}

              {}
              {!loading &&
                orders.length > 0 &&
                orders.map((order) => (
                  <div
                    key={order.id}
                    className="order-card"
                    onClick={() =>
                      navigate(`/confirmordersdetails/${order.id}`)
                    }
                  >
                    {/* Icon */}
                    <div className="order-icon">
                      <span className="lockicon">
                        <i className="fa fa-lock"></i>
                      </span>
                    </div>

                    {/* Center */}
                    <div className="order-center">
                      <h5 style={{ color: "red" }}>
                        طلب رقم #{order.orderNumber}
                      </h5>
                      <span className="order-items mb-5">
                        {order.count_items || 1} منتج
                      </span>
                    </div>

                    {/* Right */}
                    <div className="order-left">
                      <span
                        className={`order-status ${
                          statusConfig[order.status]?.className || ""
                        }`}
                      >
                        {statusConfig[order.status]?.label || order.status}
                      </span>

                      <div
                        className="comorder-price pt-4"
                        style={{ marginLeft: "62px" }}
                      >
                        <span className="price-number">
                          {order.final_total}
                        </span>
                        <span className="price-currency"> ر.س</span>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}